import { EnumTipoPedido } from "../../enums/enum-tipo-pedido";

export class TipoPedidoModel {
    constructor(
        public codigo: EnumTipoPedido = EnumTipoPedido.LOCAL,
        public descricao: string = ''
    ) { }
}